import React from 'react';

const CustomLoadingOverlay = (props) => {
  return (
    <div style={styles.overlay}>
      <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" stroke="#007bff">
        <g fill="none" fillRule="evenodd">
          <g transform="translate(2 2)" strokeWidth="4">
            <circle strokeOpacity=".5" cx="18" cy="18" r="18"/>
            <path d="M36 18c0-9.94-8.06-18-18-18">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
          </g>
        </g>
      </svg>
      <div style={styles.message}>{props.loadingMessage}</div>
    </div>
  );
};

const styles = {
  overlay: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: '#333',
    fontSize: '16px'
  },
  message: {
    marginTop: '10px'
  }
};

export default CustomLoadingOverlay;